import { http } from 'http';

export default {
  createOperation: (partnerId, params) => http.post(`/partners/${partnerId}/operations`, params),

  appliedConsents: (guid, params) => http.post(`/webh/appliedconsents?id=${guid}`, params),

  operationsStepback: params => http.post('/webh/operations/stepback', params),

  updateSign: params => http.post('/webh/campaigns/Sign', params),

  electronicSignature: params => http.post('/webh/campaigns/ElectronicSignature', params),

  registerSignature: params => http.post('/webh/campaigns/RegisterSignature', params),

  stripeRepayment: params => http.post('/webh/stripe/repayment', params),

  stripePaymentCheck: params => http.post('/webh/stripe/paymentCheck', params),

  uploadStudyDocumentation: guid =>
    http.post(`webh/operations/UploadStudyDocumentation?operationGuid=${guid}`),

  cancelOperation: params => http.post('/webh/operations/cancel', params),

  validateDocument: data => http.post('/edoc/validate', data),

  getDocuments: fileNames => http.post('/edoc/documents', { fileNames })
};
